import React from 'react';
import PropTypes from 'prop-types';
import ContactList from './ContactList';
import {Panel} from 'react-bootstrap';
import GreenLeafApi from '../utils/GreenLeafApi';

class ContactsPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contacts: [],
    };

    this.deleteContact = this.deleteContact.bind(this);
    this.fetchContacts = this.fetchContacts.bind(this);
  }

  async componentDidMount() {
    try {
      await this.fetchContacts();
    } catch (e) {
      this.props.onError(e);
    }
  }

  async fetchContacts() {
    const contacts = (await GreenLeafApi.Contact.get({companyId: this.props.company_id}));
    this.setState({contacts: contacts.data});
  }

  async deleteContact(id) {
    try {
      await GreenLeafApi.Contact.delete(id);
      await this.fetchContacts();
    } catch(e) {
      this.props.onError(e);
    }
  }

  render() {
    return(
      <div>
        <Panel>
          <Panel.Heading>
            <Panel.Title data-cy="contacts-panel" componentClass="h3">Contacts</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <ContactList
              company_id={this.props.company_id}
              contacts={this.state.contacts}
              deleteContact={this.deleteContact}
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

ContactsPanel.propTypes = {
  contacts: PropTypes.array,
  onError: PropTypes.func.isRequired,
};

export default ContactsPanel;


// WEBPACK FOOTER //
// ./src/components/contacts/ContactsPanel.js